<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("All Staking") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="getAllInvest">
      <div class="panel-body form-horizontal">
        <div class="form-group">
          <label for="filter" class="col-xs-4 control-label">{{
            $t("Coin")
          }}</label>
          <div class="col-xs-5">
            <select id="filter" v-model="filter" class="form-control">
              <option class="coin" value="ALL">ALL</option>
              <option
                class="coin"
                v-for="c in getCurrency"
                v-bind:key="c.id"
                v-bind:value="c.coin"
                >{{ c.coin }}</option
              >
            </select>
          </div>
        </div>
      </div>

      <div class="container-center lg animated fadeIn">
        <div v-for="b in getAllInvest" v-bind:key="b._id">
          <div
            v-if="
              b.currencyIN == filter ||
                b.currencyOUT == filter ||
                (filter == 'ALL' &&
                  b.type == 'STAKING' &&
                  b.avail / 1 >= b.min_invest / 1)
            "
          >
            <div
              v-bind:class="
                'panel panel-filled text-center ' + quota(b.avail, b.min_invest)
              "
            >
              <div class="panel-heading pointer" v-on:click="expand(b._id)">
                <div class="panel-tools">
                  <span
                    class="m-r-md panel-close"
                    v-on:click="deletebox(b._id)"
                  >
                    <i class="fad fa-trash-alt"></i>
                  </span>
                  <a class="panel-toggle" v-if="expanded != b._id">
                    <i class="fad fa-chevron-down"></i>
                  </a>
                  <a class="panel-toggle" v-else>
                    <i class="fad fa-chevron-up"></i>
                  </a>
                </div>
                <div
                  class="panel-tools-left animated tada infinite"
                  v-if="
                    b.avail / 1 <= b.total / 2 &&
                      b.avail / 1 >= b.min_invest / 1
                  "
                >
                  <span class="label label-sell "
                    ><i class="fad fa-fire"></i> HOT <i class="fad fa-fire"></i
                  ></span>
                </div>

                <div
                  class="panel-tools-left animated tada infinite"
                  v-else-if="isNew(b.createdAt)"
                >
                  <span class="label label-info "
                    ><i class="fad fa-sparkles"></i> NEW
                    <i class="fad fa-sparkles"></i
                  ></span>
                </div>
                <div class="coin">
                  <img :src="require(`@/assets/tokens/${b.currencyIN}.png`)" />
                  <i class="fad fa-arrow-circle-right m-l-md"></i>
                  <img :src="require(`@/assets/tokens/${b.currencyOUT}.png`)" />
                </div>

                <div class="m-t-xs">
                  {{ $t("Staking") }}
                  <span class="text-accent"
                    >{{ (b.period / b.ratio).toLocaleString() }}
                    {{ b.currencyIN }}
                  </span>
                  {{ $t("toearn") }}
                  <span class="text-accent">{{ 1 }} {{ b.currencyOUT }} </span>
                  {{ $t("dailyrewards") }} <br />
                  ({{ $t("total") }}
                  <span class="text-accent"
                    >{{ b.period }} {{ b.currencyOUT }}</span
                  >) {{ $t("Capitalreturnafter") }} {{ b.period }}
                  {{ $t("days") }}
                </div>
                <div>
                  <h3 class="text-buy font-bold" v-if="getCoins[b.currencyOUT]">
                    {{
                      usd(
                        (getCoins[b.currencyOUT].last_price * 36500) /
                          ((b.period / b.ratio) *
                            getCoins[b.currencyIN].last_price)
                      )
                    }}<small class="m-l-xs">%</small>
                  </h3>
                  <h3 class="text-buy font-bold" v-else>
                    {{ 0 }}<small class="m-l-xs">%</small>
                  </h3>
                  <p class="yield">Estimated Annual Yield</p>
                </div>
              </div>
              <div class="panel-body" v-if="expanded == b._id">
                <div class="row">
                  <div class="col-xs-12 text-right m-t-md">
                    <div class="row">
                      <div class="col-xs-6">
                        <small class="stat-label">{{
                          $t("MinHoldings")
                        }}</small>
                        <h5 class="m-t-xs">
                          {{ b.min_invest.toLocaleString() }}
                          {{ b.currencyIN }}
                        </h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{
                          $t("Capitalreturnafter")
                        }}</small>
                        <h5 class="m-t-xs">{{ b.period }} {{ $t("days") }}</h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{
                          $t("DailyProfit")
                        }}</small>
                        <h5 class="m-t-xs">
                          {{ b.ratio / b.period }}
                          {{ b.currencyOUT }}/{{ b.currencyIN }}
                        </h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{ $t("Total") }}</small>
                        <h5 class="m-t-xs">
                          {{ b.total.toLocaleString() }}
                          {{ b.currencyIN }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 m-t-md">
                    <h6>
                      {{ $t("Available") }}
                      <span class="text-accent"
                        >{{ (b.avail / 1).toLocaleString() }}({{
                          b.currencyIN
                        }})</span
                      >
                    </h6>
                    <div class="progress m-t-xs full progress-small">
                      <div
                        v-bind:style="
                          'width: ' + (100 - (100 * b.avail) / b.total) + '%'
                        "
                        aria-valuemax="100"
                        aria-valuemin="0"
                        v-bind:aria-valuenow="100 - (100 * b.avail) / b.total"
                        role="progressbar"
                        class="progress-bar progress-bar-warning"
                      >
                        <span class="sr-only"
                          >{{ 100 - (100 * b.avail) / b.total }}% Complete
                          (success)</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              (b.currencyIN == filter ||
                b.currencyOUT == filter ||
                filter == 'ALL') &&
                b.type == 'SWAPPING' &&
                getCoins[b.currencyOUT] &&
                getCoins[b.currencyIN] &&
                b.avail / 1 >= b.min_invest / 1
            "
          >
            <div
              v-bind:class="
                'panel panel-filled text-center ' + quota(b.avail, b.min_invest)
              "
            >
              <div class="panel-heading pointer" v-on:click="expand(b._id)">
                <div class="panel-tools">
                  <span
                    class="m-r-md panel-close"
                    v-on:click="deletebox(b._id)"
                  >
                    <i class="fad fa-trash-alt"></i>
                  </span>
                  <a class="panel-toggle" v-if="expanded != b._id">
                    <i class="fad fa-chevron-down"></i>
                  </a>
                  <a class="panel-toggle" v-else>
                    <i class="fad fa-chevron-up"></i>
                  </a>
                </div>
                <div
                  class="panel-tools-left animated tada infinite"
                  v-if="
                    b.avail / 1 <= b.total / 2 &&
                      b.avail / 1 >= b.min_invest / 1
                  "
                >
                  <span class="label label-sell "
                    ><i class="fad fa-fire"></i> HOT <i class="fad fa-fire"></i
                  ></span>
                </div>

                <div
                  class="panel-tools-left animated tada infinite"
                  v-else-if="isNew(b.createdAt)"
                >
                  <span class="label label-info "
                    ><i class="fad fa-sparkles"></i> NEW
                    <i class="fad fa-sparkles"></i
                  ></span>
                </div>
                <div class="coin">
                  <img :src="require(`@/assets/tokens/${b.currencyIN}.png`)" />
                  <i class="fad fa-arrow-circle-right m-l-md"></i>
                  <img :src="require(`@/assets/tokens/${b.currencyOUT}.png`)" />
                </div>
                <div class="m-t-sm">
                  {{ $t("Swapping") }}
                  <span class="text-accent">1 {{ b.currencyIN }}</span>
                  {{ $t("toget") }}
                  <span class="text-accent"
                    >{{ b.ratio.toLocaleString() }} {{ b.currencyOUT }}</span
                  >
                  {{ $t("in") }} {{ b.period }} {{ $t("days") }}
                  <h3
                    class="text-mute font-bold"
                    v-if="getCoins[b.currencyOUT]"
                  >
                    {{
                      usd(
                        ((((b.ratio * getCoins[b.currencyOUT].last_price) /
                          getCoins[b.currencyIN].last_price -
                          1) *
                          100) /
                          b.period) *
                          365
                      )
                    }}<small class="m-l-xs">%</small>
                  </h3>
                  <h3 class="text-buy font-bold" v-else>
                    {{ 0 }}<small class="m-l-xs">%</small>
                  </h3>
                  <p class="yield">Estimated Annual Yield</p>
                </div>
              </div>
              <div class="panel-body" v-if="expanded == b._id">
                <div class="row">
                  <div class="col-xs-12 text-right m-t-md">
                    <div class="row">
                      <div class="col-xs-6">
                        <small class="stat-label">{{ $t("MinSwap") }}</small>
                        <h5 class="m-t-xs">
                          {{ b.min_invest.toLocaleString() }}
                          {{ b.currencyIN }}
                        </h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{ $t("InPeriod") }}</small>
                        <h5 class="m-t-xs">{{ b.period }} {{ $t("days") }}</h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{ $t("Rate") }}</small>
                        <h5 class="m-t-xs">
                          {{ b.ratio.toLocaleString() }}
                          {{ b.currencyOUT }}/{{ b.currencyIN }}
                        </h5>
                      </div>

                      <div class="col-xs-6">
                        <small class="stat-label">{{ $t("Total") }}</small>
                        <h5 class="m-t-xs">
                          {{ b.total.toLocaleString() }}
                          {{ b.currencyIN }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 m-t-md">
                    <h6>
                      {{ $t("Available") }}
                      <span class="text-accent"
                        >{{ (b.avail / 1).toLocaleString() }}({{
                          b.currencyIN
                        }})</span
                      >
                    </h6>
                    <div class="progress m-t-xs full progress-small">
                      <div
                        v-bind:style="
                          'width: ' + (100 - (100 * b.avail) / b.total) + '%'
                        "
                        aria-valuemax="100"
                        aria-valuemin="0"
                        v-bind:aria-valuenow="100 - (100 * b.avail) / b.total"
                        role="progressbar"
                        class="progress-bar progress-bar-warning"
                      >
                        <span class="sr-only"
                          >{{ 100 - (100 * b.avail) / b.total }}% Complete
                          (success)</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import investBox from "@/api/investbox";
import func from "@/widgets/func";
import { mapGetters, mapActions } from "vuex";
import nativeToast from "native-toast";

export default {
  data() {
    return {
      filter: "ALL",
      expanded: null
    };
  },
  computed: mapGetters(["getCurrency", "getAllInvest", "getCoins"]),
  methods: {
    ...mapActions(["fetchAllInvest"]),
    expand(id) {
      if (this.expanded == id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
    },
    percent(a) {
      return a.toFixed(2);
    },
    fixed(a) {
      return func.fixed(a);
    },
    usd(a) {
      return func.fixed2(a);
    },
    quota(avail, min_invest) {
      if (avail / 1 < min_invest / 1) return "outofquota";
    },
    isNew(date) {
      const begin = new Date(date);
      const today = new Date();
      const diffTime = today.getTime() - begin.getTime();
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      if (diffDays < 7) return true;
      else return false;
    },
    async deletebox(_id) {
      if (confirm("Are you sure you want to delete investbox?")) {
        await investBox
          .delete({
            _id: _id
          })
          .then(() => {
            nativeToast({
              message: "Successfully.",
              position: "top",
              timeout: 3000,
              type: "success"
            });
          })
          .catch(err => {
            nativeToast({
              message: err.message,
              position: "top",
              timeout: 3000,
              type: "danger"
            });
          });
      }
    }
  },
  created() {
    this.fetchAllInvest();
  }
};
</script>

<style scoped>
.container-center {
  margin: 50px auto 0;
  padding: 0px 5px 100px 5px;
}
.coin img {
  margin-left: 20px;
}
.coin {
  color: white;
  font-size: 25px;
}
.progress-small,
.progress-small .progress-bar {
  height: 30px;
}
.progress {
  border-radius: 20px;
  margin-bottom: 0px;
  background-color: transparent;
  background-image: linear-gradient(0deg, #192330, #414011 50%, #192330);
  height: 30px;
  position: relative;
}
.full .progress-bar-warning {
  background-image: linear-gradient(180deg, #ffe170, #ffb900);
  height: 22px;
  border-radius: 22px;
  position: absolute;
  top: 4px;
  left: 0px;
}
.full .progress-bar-warning {
  border-right: 0px solid #fff;
}
.progress-bar {
  padding-right: 0px;
}
.text-admin {
  color: #32353c;
}
.outofquota {
  opacity: 0.5;
}
.panel-tools-left {
  margin-top: 0;
  padding: 0;
  position: absolute;
}
.border-right {
  border-right: 2px solid #949ba2;
  padding-right: 5px;
}
.yield {
  font-size: 11px;
  margin-top: -10px;
  margin-bottom: 0px;
}
.topmarket {
  max-width: 1024px;
  padding-top: 8px;
  position: static;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
  z-index: 10;
  margin: 37px auto 0;
}
.active p {
  padding-bottom: 5px;
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
  margin: -3px 0 0px;
}
</style>
